import React from "react";
import Box from "@mui/material/Box";
import Skeleton from "@mui/material/Skeleton";
import Typography from "@mui/material/Typography";

import { styles } from "../styles";

const FormSkeleton: React.FC = () => {
  return (
    <Box sx={styles.form}>
      <Box sx={styles.formContent}>
        <Typography variant="h3" sx={{ mb: 0.5 }}>
          Заповніть форму
        </Typography>
        <Typography variant="body2" sx={{ mb: 3 }} color="grey700">
          Для генерування посилання на оплату необхідно внести реквізити
        </Typography>

        <Typography variant="caption" sx={{ mb: 1, display: "block" }}>
          Реквізити отримувача
        </Typography>
        <Skeleton variant="rectangular" height={56} sx={styles.skeleton} />

        <Typography variant="caption" sx={{ mb: 1, display: "block" }}>
          Сума
        </Typography>
        <Skeleton variant="rectangular" height={56} sx={styles.skeleton} />

        <Typography variant="caption" sx={{ mb: 1, display: "block" }}>
          Призначення платежу
        </Typography>
        <Skeleton variant="rectangular" height={120} sx={styles.skeleton} />
      </Box>
      <Box sx={styles.buttonWrapper}>
        <Skeleton variant="rectangular" height={56} sx={{ borderRadius: 10 }} />
      </Box>
    </Box>
  );
};

export default FormSkeleton;
